<div class="grid">
	<div [class]="actionLayout('left')">
		<p-button id="addMtmaContact" label="{{ 'ADD_CONTACT' | translate }}" (click)="addContact()" icon="pi cm-plus"
			[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
		</p-button>
	</div>
	<div [class]="actionLayout('center')">
		<div class="flex flex-column justify-content-center gap-2">
			<span class="flex align-items-center justify-content-center font-semibold">
				<i class="pi cm-memory-storage mr-1"></i>
				{{'MEMORY_USAGE' | translate }}: {{memorySize}} / {{maxMemorySize}}
			</span>
			<p-progressBar [value]="getValueMemory()" styleClass="surface-900">
				<ng-template pTemplate="content" let-value>
					<span *ngIf="getValueMemory() > 4">{{getValueMemory()}} %</span>
				</ng-template>
			</p-progressBar>
		</div>
	</div>
	<div [class]="actionLayout('right')">
		<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
			<i class="pi cm-search"></i>
			<input [formControl]="searchFilter" pInputText type="text" id="mtma-contact-input-search" class="surface-900"
				placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()" maxlength="60" />
		</span>
	</div>
	<div class="col-12">
		<div class="card border-round">
			<p-table #tableContactsList dataKey="ObjId" [value]="mtmaContacts" [lazy]="true"
				(onLazyLoad)="loadContacts($event)" [paginator]="true" [totalRecords]="totalRecords"
				[loading]="contactsLoading" [rows]="pageSize" [showCurrentPageReport]="true" sortField="Name" [sortOrder]="1"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th style="width: 5rem"></th>
						<th>
							<div pSortableColumn="Name" class="flex align-items-center justify-content-center">{{ 'NAME' |
								translate }}
								<p-sortIcon field="Name"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="Phone" class="flex align-items-center justify-content-center">{{ 'PHONE' |
								translate }}
								<p-sortIcon field="Phone"></p-sortIcon>
							</div>
						</th>
						<th>
							<div pSortableColumn="Description" class="flex align-items-center justify-content-center">{{
								'DESCRIPTION' |
								translate }}
								<p-sortIcon field="Description"></p-sortIcon>
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'DIAL_TO_OPEN' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'RULES' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'TEMPORARY_GROUPS' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-contact let-expanded="expanded">
					<tr>
						<td>
							<p-button [pRowToggler]="contact" [rounded]="true"
								styleClass="surface-900 hover:bg-primary border-1 border-600"
								[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'"
								(click)="getUnitsContact(contact)"></p-button>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ contact.Name }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'PHONE' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ contact.Phone }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'DESCRIPTION' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ contact.Description }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'DIAL_TO_OPEN' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getTextAction(contact) }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'RULES' | translate }}</span>
							<div class="flex align-items-center justify-content-center">
								<p-tag *ngIf="contact.RuleId !== undefined" [value]="('ACTIVE' | translate)"
									severity="success"></p-tag>
							</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'TEMPORARY_GROUPS' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getTemporaryRule(contact) }}</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" id="buttonDeviceContactEdit-{{contact.Name}}"
									[disabled]="isActiveTask" tooltipPosition="bottom" icon="pi cm-pencil" size="large"
									(click)="editContact(contact)" [rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" id="buttonDeviceContactDelete-{{contact.Name}}"
									[disabled]="isActiveTask" tooltipPosition="bottom" icon="pi cm-trash" size="large"
									(click)="delete(contact)" [rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="rowexpansion" let-contact class="w-full">
					<tr class="surface-400">
						<td colspan="12">
							<div class="flex flex-row w-full align-items-center"
								[class]="this.screenWidth > COLUMN_TITLE_MIN_WD ? 'justify-content-center' : 'justify-content-between'">
								<span class="font-semibold">{{ 'UNITS' | translate }}: </span>
								<p-tag *ngFor="let unit of contact.Units" [value]="unit.Name" severity="info" class="ml-3"></p-tag>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>